import { useQueryClient } from "@tanstack/react-query";
import { useRequestStatus } from "Utilities";
import { portfolioService } from "modules/portfolio/client/PortfolioService";
import portfolioKeys from "./portfolio.queryKeys";
import { FeedbackStatus } from "../types";

const useDeclineFeedback = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: () => void;
}) => {
  const queryClient = useQueryClient();
  const { error, setRequestStatus, isSuccessful, isLoading } = useRequestStatus();

  const declineFeedback = ({ eventId, feedbackId }: { eventId: string; feedbackId: string }) => {
    setRequestStatus({ status: "pending", error: "" });

    portfolioService
      .patchFeedback(feedbackId, FeedbackStatus.DECLINED)
      .then(() => {
        setRequestStatus({ status: "success", error: "" });
        queryClient.invalidateQueries({
          queryKey: portfolioKeys.feedbackList(),
        });
        queryClient.removeQueries({
          queryKey: portfolioKeys.feedbackDetail(eventId),
        });
        onSuccess();
      })
      .catch((error) => {
        setRequestStatus({ status: "error", error });
        onError();
      });
  };

  return {
    declineFeedback,
    decliningError: error,
    decliningFeedback: isLoading,
    declineSuccessful: isSuccessful,
  };
};

export default useDeclineFeedback;
